import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapGetters('auth', ['userPermissions','userRole']),
}

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    leftSidebarType: (state) => state.leftSidebarType,
    layoutWidth: (state) => state.layoutWidth,
    topbar: (state) => state.topbar,
    loader: (state) => state.loader
  })
}


export const partnerComputed = {
  ...mapGetters('partner', ['currentDriver']),
}


export const layoutMethods = mapActions('layout', ['changeLayoutType', 'changeLayoutWidth', 'changeLeftSidebarType', 'changeTopbar', 'changeLoaderValue'])

export const authMethods = mapActions('auth', ['login', 'registeruser', 'logout'])

export const partnerMethods = mapActions('partner', ['selectDriver'])

export const notificationMethods = mapActions('notification', ['success', 'error', 'clear'])
